import api from './api';
// 登录
export function login(params) {
  return api.post('/log/login', params).then(res => res);
}
// 获取数据字典
export function getDictionaryList(params) {
  return api.post('/dic/getdiclist.html', params).then(res => res);
}
// 获取数据字典ID获取数据字典项
export function getdiclistbypid(params) {
  return api.post('/dic/getdiclistbypid.html', params).then(res => res);
}
// 获取验证码
export function getVerify(params) {
  return api.get('/log/getVerify', params).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/login.js